import { render, staticRenderFns } from "./landingLayout.vue?vue&type=template&id=333d8ae0&scoped=true&"
import script from "./landingLayout.vue?vue&type=script&lang=ts&"
export * from "./landingLayout.vue?vue&type=script&lang=ts&"
import style0 from "./landingLayout.vue?vue&type=style&index=0&id=333d8ae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333d8ae0",
  null
  
)

export default component.exports